import OSmsModalOtgSuccess from './o-sms-modal-otg-success.vue';

export default OSmsModalOtgSuccess;